/* eslint-disable prefer-arrow-callback, func-names */

$(function () {
    let buttonEnabled = false;

    $('#lkr-donation-panel input[type=radio]').on('keydown', function (e) {
        const radio = $(this);

        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            radio.closest('#lkr-donation-panel').find('label').removeClass('selected');
            radio.closest('label').addClass('selected');
            radio.prop('checked', true);
            $('#lkr-donation-panel input[type=submit]')
                .removeAttr('disabled')
                .addClass('active')
                .css('cursor', 'pointer')
                .fadeTo(300, 1)
                .attr('aria-label', `Add a ${radio.attr('aria-label')} donation to Music Will to your shopping cart.`);
            buttonEnabled = true;
            setTimeout(function () {
                $('#lkr-donation input[type=submit]').focus();
            }, 100);
        }
    });

    $('#lkr-donation-panel').on('click', 'input[type=radio]', function () {
        const radio = $(this);

        // Style add to cart button
        if ($('#lkr-donation-panel').hasClass('hide_atc_btn') && radio.is(':checked')) {
            $('#lkr-donation-panel input[type=submit]').fadeTo(300, 1);
            $('.no-thanks-container').css('display', 'block');
        }

        if (radio.is(':checked')) {
            $('#lkr-donation-panel input[type=submit]')
                .removeAttr('disabled')
                .addClass('active')
                .css('cursor', 'pointer')
                .attr('aria-label', `Add a ${radio.attr('aria-label')} donation to Music Will to your shopping cart.`);
            buttonEnabled = true;
        }

        // Style active donate btn
        radio.closest('#lkr-donation-panel').find('label').removeClass('selected');
        radio.closest('label').addClass('selected');
    });

    $('#lkr-donation-panel').on('keyup', function (e) {
        if (e.key === 'Escape') {
            $('#lkr-donation-panel').find('label').removeClass('selected');
            $('#lkr-donation-panel').find('input').prop('checked', false);
            $('#lkr-donation-panel input[type=submit]').prop('disabled', true).removeClass('active').css('cursor', 'not-allowed');
            buttonEnabled = false;
        }
    });

    // Form submit
    $('form#lkr-donation input[type="submit"]').on('keyup', function (e) {
        if (buttonEnabled) {
            $(this).trigger('submit');
        } else {
            e.preventDefault();
        }
    });
});
